import { render, staticRenderFns } from "./PopupTariffLimits.vue?vue&type=template&id=3ffb3538&scoped=true&lang=pug&"
import script from "./PopupTariffLimits.vue?vue&type=script&lang=js&"
export * from "./PopupTariffLimits.vue?vue&type=script&lang=js&"
import style0 from "./PopupTariffLimits.vue?vue&type=style&index=0&id=3ffb3538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb3538",
  null
  
)

export default component.exports